import { render } from "./TextBannerWarning.vue?vue&type=template&id=0f5e70a2&scoped=true"
import script from "./TextBannerWarning.vue?vue&type=script&lang=js"
export * from "./TextBannerWarning.vue?vue&type=script&lang=js"

import "./TextBannerWarning.vue?vue&type=style&index=0&id=0f5e70a2&scoped=true&lang=scss"
import "./TextBannerWarning.vue?vue&type=style&index=1&id=0f5e70a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5e70a2"]])

export default __exports__